// popup_first order only: the plan the (still anonymous) visitor picked on the
// pre-signup paywall popup, held until registration produces an authToken we can
// charge with.
//
// Why sessionStorage: the pick happens on load A and the charge may happen on load B
// — the Google OAuth round-trip reloads the lander (backend returns to
// ?auth_token=…), so React state is gone by then. sessionStorage survives that
// same-tab round-trip while scoping the choice to this visit (a later visit re-picks
// rather than silently charging a stale plan). Same reasoning as the nav-config /
// premium-token stickiness in contexts/GrowthBookContext.jsx.
//
// The whole plan object is stored, not just its id, so the post-registration
// checkout needs no second /subscription-plans fetch and builds the SAME checkout
// texts (price, duration, bonus hearts) the user was shown. The backend re-reads the
// plan by id when it creates the Upgate order, so nothing security-relevant rides on
// this snapshot.
const SELECTED_PLAN_KEY = 'csfw_paywall_selected_plan';

// → { plan, bonusTokens, currencySymbol, currencyCode, locale, isFlatRebill,
//      priceMultiplier } | null
export const getSelectedPlan = () => {
  try {
    const raw = sessionStorage.getItem(SELECTED_PLAN_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.plan?._id ? parsed : null;
  } catch {
    return null;
  }
};

export const setSelectedPlan = (selection) => {
  try {
    sessionStorage.setItem(SELECTED_PLAN_KEY, JSON.stringify(selection));
  } catch {
    // ignore storage failures — the caller keeps it in React state too, so the
    // flow still works as long as the page doesn't reload (i.e. every path
    // except the OAuth round-trip).
  }
};

export const clearSelectedPlan = () => {
  try {
    sessionStorage.removeItem(SELECTED_PLAN_KEY);
  } catch {
    // ignore storage failures
  }
};

export default { getSelectedPlan, setSelectedPlan, clearSelectedPlan };
